<template>
  <div class="form-list">
    <header>
      <h1>Liste des formulaires</h1>
      <button class="create-button" @click="createNewForm">Créer un nouveau formulaire</button>
    </header>
    <div v-if="forms.length" class="forms-list">
      <paginate :count="count" v-model="offset" :limit="limit"></paginate>
      <div v-for="form in paginatedForms" :key="form.id" class="form-item">
        <div class="form-info">
          <h3>{{ form.title }}</h3>
          <small>créé le {{ form.createdAt | format('d/MM/yyyy HH:mm:ss') }}</small>
          <small v-if="form.updatedAt"> édité le {{ form.updatedAt | format('d/MM/yyyy HH:mm:ss') }}</small>
        </div>
        <div class="form-actions">
          <select v-model="form.status" @change="changeStatus(form, form.status)">
            <option value="draft">Brouillon</option>
            <option value="active">Activé</option>
            <option value="archived">Archivé</option>
          </select>
          <select v-model="form.scope" @change="changeScope(form, form.scope)">
            <option value="application">Candidature</option>
            <option value="survey">Enquêtes</option>
            <option value="nps">Nps</option>
          </select>
          <button @click="duplicateForm(form)">Dupliquer</button>
          <button @click="editForm(form)">Modifier</button>
          <button @click="previewForm(form)">Aperçu</button>
          <button class="delete-button" @click="deleteForm(form.id)">Supprimer</button>
        </div>
      </div>
    </div>
    <div v-else class="no-forms">
      <p>Aucun formulaire disponible</p>
    </div>
  </div>
</template>

<script>
import Paginate from '/layout/paginate'
import Form from '/form/entity'

export default {
  name: 'hippolyte.conciliator.form.list',
  components: { Paginate },
  data() {
    return {
      forms: [],
      offset: 0,
      limit: 10
    }
  },
  computed: {
    count() {
      return this.forms.length
    },
    paginatedForms() {
      const end = this.offset + this.limit
      return this.forms.slice(this.offset, end)
    }
  },
  mounted() {
    this.load()
  },
  // @todo ajouter des filtres alphabétiques et par date
  // @todo ajouter une recherche par mot clefs
  methods: {
    async load() {
      const storedForms = await Form.list(this.$socket)
      if (storedForms.forms.length) {
        this.forms = storedForms.forms
      }
    },
    createNewForm() {
      this.$router.push({ name: 'form_creator' })
    },
    async changeStatus(form, status) {
      const editedForm = new Form(form, this.$socket)
      editedForm.status = status
      await editedForm.save()
    },
    async changeScope(form, scope) {
      const editedForm = new Form(form, this.$socket)
      editedForm.scope = scope
      await editedForm.save()
    },
    async duplicateForm(form) {
      const newForm = new Form({ ...form, title: `Copy de ${form.title}` }, this.$socket)
      newForm.content.title = newForm.title
      delete newForm.id
      delete newForm.createdAt
      delete newForm.updatedAt
      await newForm.save()
      await this.load()
    },
    editForm(form) {
      this.$router.push({ name: 'form_creator', params: { form: JSON.stringify(form), id: form.id } })
    },
    previewForm(form) {
      this.$router.push({ name: 'form_creator', params: { form: JSON.stringify(form), id: form.id, preview: true } })
    },
    async deleteForm(id) {
      await this.$confirm().open({
        title: 'Voulez vous vraiment supprimer le formulaire ?',
        valid: 'Supprimer',
        cancel: 'Annuler'
      })
      .then(async () => {
        // L'utilisateur a confirmé, on continue la suppression
        const form = new Form({ id }, this.$socket)
        await form.delete()
        this.forms = this.forms.filter(form => form.id !== id)
        this.$confirm().close()
      }, () => {})
    }
  }
}
</script>

<style lang="stylus" scoped>
@require '~/colors.styl'

header
  display flex
  align-items center
  justify-content space-between

.form-list
  padding 20px

.forms-list
  margin 20px 0

.form-item
  display flex
  justify-content space-between
  align-items center
  padding 15px
  background $color-white

.form-info
  flex 1

  h3
    margin 0 0 5px
    color $hippolyte-black

  p
    margin 0
    color $color-gray-dark

.form-actions
  display flex
  gap 10px

  button
    padding 8px 12px
    border-radius 4px
    border none
    cursor pointer
    transition background-color 0.2s

    &:hover
      opacity 0.9

  .delete-button
    background-color $color-red
    color $color-white

.create-button
  padding 12px 24px
  border-radius 4px
  border none
  background $hippolyte-green
  color $color-white
  cursor pointer
  margin-top 20px

  &:hover
    background darken($hippolyte-green, 10%)

.no-forms
  text-align center
  padding 40px
  color $color-grey
</style>